import http from '../../utils/http'; //封装的拦截器及错误处理的axios
import Qs from 'qs';

const dashboardApi = {
  getChannelMenu(){
    // return new Promise((resolve, reject) => {
    //   http({ method: 'get', url: '/channel_menu.jspx' }).then(response => {
    //     resolve(response)
    //   }).catch(error => {
    //     reject(error);
    //   });
    // })
    return http({ method: 'get', url: '/channel_menu.jspx' })
  },
  getMeeting(params) {
    return http({
      method: 'post',
      url: '/meeting/v_list.jspx',
      params: params
    })
  },
  getDeclareResult(params){
    // return new Promise((resolve, reject)=>{
    //   http({ method: 'get', url: 'declare/result/get.jspx', params: params }).then(response => {
    //     resolve(response)
    //   }).catch(error => {
    //     reject(error);
    //   });
    // })
    return http({ method: 'get', url: 'declare/result/get.jspx', params: params })
  },
  productPage(params){
    // return new Promise((resolve, reject)=>{
    //   http({
    //     headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //     method: 'post', url: '/product/v_list.jspx', params: params
    //   }).then(response => {
    //     resolve(response)
    //   }).catch(error => {
    //     reject(error);
    //   });
    // })
    return http({ method: 'get', url: '/product/v_list.jspx', params: params })
  },
  getByAssess(params) {
    return http({
      method: 'post',
      url: '/product/get.jspx',
      params: params
    })
  },
  getApplyCount(params) {
    return http({
      method: 'post',
      url: '/product/declare/applyCount.jspx',
      params: params
    })
  },
  getApplyList(params) {
    return http({
      method: 'post',
      url: '/product/declare/list.jspx',
      params: params
    })
  },
  submitAssess(params){
    return http({
      method: 'post',
      url: 'assess/result/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  submitDeclare(params){
    return http({
      method: 'post',
      url: 'product/declare/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  submitApply(params){
    return http({
      method: 'post',
      url: 'declare/result/submit.jspx',
      data: Qs.stringify(params)
    });
  },
  removeDeclare(params){
    return http({
      method: 'post',
      url: 'product/declare/remove.jspx',
      data: Qs.stringify(params)
    });
  },
  submitAssessPwd(params){
    return http({
      method: 'post',
      url: 'member/assess/password.jspx',
      data: Qs.stringify(params)
    });
  },
  getMember(params) {
    return http({
      method: 'get',
      url: '/member/user_account.jspx',
      params: params
    })
  },
  getMeetingConfig(params) {
    return http({
      method: 'post',
      url: '/meeting/config/options.jspx',
      params: params
    })
  },
  submitDrs(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'post',
      url: '/product/drs/submit.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  submitSubscribe(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'post',
      url: '/meeting/count/submit.jspx',
      data: Qs.stringify(reqdata)
    })
  },
};
export default  dashboardApi;



// WEBPACK FOOTER //
// ./src/api/dashboard/index.js